import React from 'react';
import { FCC } from 'react';
import { IRowProps } from './types';

export const Row: FCC<IRowProps> = (props) => {
  return (
    <div className="row" style={{ paddingTop: props.section ? '15px' : '', ...props.style }}>
      {props.children}
    </div>
  );
};

export default Row;
